import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { confirm } from 'devextreme/ui/dialog';
import { DialogIdentifier } from '../dialog-identifier';

@Injectable()
export class DialogControllerService {
  private activeDialog = new BehaviorSubject<string>('');

  constructor() {}

  get activeDialogValue(): string {
    return this.activeDialog.getValue();
  }

  get activeDialogStream(): Observable<string> {
    return this.activeDialog.asObservable();
  }

  public confirm(message: string): Promise<boolean> {
    return confirm(message, '');
  }

  public openAboutDialog(): void {
    this.openDialog(DialogIdentifier.AboutView);
  }

  public openCertDialog(): void {
    this.openDialog(DialogIdentifier.CertView);
  }

  public openUserProfileDialog(): void {
    this.openDialog(DialogIdentifier.UserProfileView);
  }

  public openUploadDialog(): void {
    this.openDialog(DialogIdentifier.UploadView);
  }

  public closeDialog(): void {
    this.activeDialog.next('');
  }

  private openDialog(dialog: string): void {
    this.activeDialog.next(dialog);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/dialog-controller/dialog-controller.service.ts